import request from '@/utils/request'

// 예시 조회
export function getTrainingScenarioSampleData(params, isNotify) {
  return request({
    url: '/api/getTrainingScenarioSampleData',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 조회
export function getEmergencyResponseTraining(params, isNotify) {
  return request({
    url: '/api/getEmergencyResponseTraining',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
//삭제
export function deleteEmergencyResponseTraining(params, isNotify) {
  return request({
    url: '/api/deleteEmergencyResponseTraining',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}

// 시나리오 조회
export function getEmergencyResponseTrainingScenario(params, isNotify) {
  return request({
    url: '/api/getEmergencyResponseTrainingScenario',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
export function saveEmergencyResponseTrainingScenario(params, isNotify) {
  return request({
    url: '/api/saveEmergencyResponseTrainingScenario',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

// 실시보고서 조회
export function getEmergencyResponseTrainingResult(params, isNotify) {
  return request({
    url: '/api/getEmergencyResponseTrainingResult',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 실시보고서 실시일자목록 조회
export function getTrainingResultDateList(params, isNotify) {
  return request({
    url: '/api/getTrainingResultDateList',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved, deleted
  })
}
// 실시보고서 저장
export function saveEmergencyResponseTrainingResult(params, isNotify) {
  return request({
    url: '/api/saveEmergencyResponseTrainingResult',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}
// 실시보고서 삭제
export function deleteEmergencyResponseTrainingResult(params, isNotify) {
  return request({
    url: '/api/deleteEmergencyResponseTrainingResult',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}

// 실시보고서 참여자 삭제
export function updateEmergencyResponseTrainingResultLook(params, isNotify) {
  return request({
    url: '/api/updateEmergencyResponseTrainingResultLook',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved, deleted
  })
}

// 시나리오 서명 얻데이트
export function updateScenarioSign(params, isNotify = false) {
  return request({
    url: '/api/updateScenarioSign',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}

// 실시보고서 서명 얻데이트
export function updateResultSign(params, isNotify = false) {
  return request({
    url: '/api/updateResultSign',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}
// 훈련알림발송
export function sendFCMTraining (params, isNotify = false) {
  return request({
    url: '/api/sendFCMTraining',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}
// 시나리오 보고서  출력
export function getTrainingScenarioReport(params, isNotify = false) {
  let responseType = 'blob'
  return request({
    url: `/api/getTrainingScenarioReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 실시보고서 출력
export function getTrainingResultReport(params, isNotify = false) {
  let responseType = 'blob'
  return request({
    url: `/api/getTrainingResultReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    responseType: responseType,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 비상사태 대응 매뉴얼 확인 근로자 명단 조회
export function getEmergencyResponseTrainingResultLook (params, isNotify = false) {
  return request({
    url: '/api/getEmergencyResponseTrainingResultLook',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}
// 비상사태 대응 매뉴얼 실시 확인 처리
export function checkEmergencyResponseTrainingResultLook (params, isNotify = false) {
  return request({
    url: '/api/checkEmergencyResponseTrainingResultLook',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: params,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved, deleted
  })
}